/**
 * @file index.tsx
 *
 * @fileoverview Shows the gallery widget when in view mode.
 */
import React from 'react';
import { OrganizationWidgetsBoxLabel } from '~/jobiqo/components/Organization/Widgets/BoxLabel';
import OrganizationGalleryWidgetViewContent from '~/jobiqo/components/Organization/Widgets/Gallery/View/components/Content';
import OrganizationGalleryWidgetViewTitle from '~/jobiqo/components/Organization/Widgets/Gallery/View/components/Title';
import { OrganizationProfile } from '~/jobiqo/types/types';
import { Box } from '~/vcl/atoms/07-box';
export interface OrganizationGalleryWidgetViewProps {
  /**
   * The current resume.
   */
  organization: OrganizationProfile;
  /**
   * The current box id.
   */
  boxId: string | undefined;
}

export const OrganizationGalleryWidgetView = (
  props: OrganizationGalleryWidgetViewProps,
) => (
  <Box
    label={
      <OrganizationWidgetsBoxLabel>
        <OrganizationGalleryWidgetViewTitle />
      </OrganizationWidgetsBoxLabel>
    }
  >
    <OrganizationGalleryWidgetViewContent {...props} />
  </Box>
);

export default OrganizationGalleryWidgetView;
